// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__Ouas-","contentBar":"styles_contentBar__nX0iW","removePadding":"styles_removePadding__5qpfx","rightSideBlock":"styles_rightSideBlock__MrdiQ"};